import React from 'react'
import ReactDOM from 'react-dom/client'
import GlobalStyle from './styles/globalStyles'
import reportWebVitals from './reportWebVitals'

import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AccessDataProvider } from './Context'

import StartPage from './pages/preconsent/StartPage'
import StepLoading from './pages/preconsent/StepLoading'
import FirstStepPage from './pages/preconsent/FirstStepPage'
import ProcedurePage from './pages/preconsent/ProcedurePage'
import Provider from './pages/consent/Provider'
import YourData from './pages/consent/YourData'
import AccessPeriod from './pages/consent/AccessPeriod'
import ShareData from './pages/consent/ShareData'
import ConsentLoading from './pages/consent/ConsentLoading'
import CustomerLogin from './pages/authenticate/CustomerLogin'
import OneTimePassword from './pages/authenticate/OneTimePassword'
import Authenticating from './pages/authenticate/AuthenticateLoading'
import SelectAccount from './pages/authorise/SelectAccount'
import ConfirmShare from './pages/authorise/ConfirmShare'
import AuthorsingLoading from './pages/authorise/AuthorisingLoading'
import CancelConfirmPage from './pages/consent/CancelConfirm'
import GenerateLoading from './pages/authorise/GenerateLoading'
import ProcessCancelling from './pages/authorise/ProcessCancelling'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <GlobalStyle />
    <AccessDataProvider>
      <BrowserRouter basename={'/cx-consent-flow'}>
        <Routes>
          <Route exact path="/" element={<StartPage />} />
          <Route exact path="/step-loading" element={<StepLoading />} />
          <Route exact path="/first-step" element={<FirstStepPage />} />
          <Route exact path="/procedure" element={<ProcedurePage />} />
          <Route exact path="/provider" element={<Provider />} />
          <Route exact path="/your-data" element={<YourData />} />
          <Route exact path="/access-period" element={<AccessPeriod />} />
          <Route exact path="/share-data" element={<ShareData />} />
          <Route exact path="/cancel-alert" element={<CancelConfirmPage />} />
          <Route exact path="/consent-loading" element={<ConsentLoading />} />
          <Route exact path="/login" element={<CustomerLogin />} />
          <Route exact path="/password" element={<OneTimePassword />} />
          <Route exact path="/authenticating" element={<Authenticating />} />
          <Route exact path="/process-cancel" element={<ProcessCancelling />} />
          <Route exact path="/select-account" element={<SelectAccount />} />
          <Route exact path="/confirm-share" element={<ConfirmShare />} />
          <Route exact path="/authorsing" element={<AuthorsingLoading />} />
          <Route exact path="/generating" element={<GenerateLoading />} />
        </Routes>
      </BrowserRouter>
    </AccessDataProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
